import {useSelector} from 'react-redux';

export const useLiveCount = ()=> useSelector(({live})=>live.count);
export const useLivePageviews = ()=> useSelector(({live})=>live.pageviews);

export const useLiveBreakPoints = ()=>{
	const pageviews = useLivePageviews();
	return (pageviews.breakpoint)? pageviews.breakpoint: [];
};

export const useLiveContentIds = ()=>{
	const pageviews = useLivePageviews();
	return (pageviews.content_id)? pageviews.content_id: [];
};

export const useLiveContentIdByIndex = (index) => useLiveContentIds()[index];
export const useLiveContentByKey = (key) => useSelector(({live})=> live.contents[key]);

export const useLiveBreakPointsCluster = (clusterFn = null) =>{
	// TODO: clustering
	const breakpoints = (clusterFn)? clusterFn(useLiveBreakPoints()): useLiveBreakPoints();
	const showBreakpoints = 5;
	if (breakpoints.length < 1) return [];
	const total = breakpoints.reduce((val, bp)=> bp.value + val, 0 );
	if(breakpoints.length <= showBreakpoints){
		return breakpoints.map((bp)=>{
			return {
				...bp,
				percentage: Math.round(bp.value / total * 100)
			}
		});
	}
	const result = breakpoints.slice(0, showBreakpoints).map((bp)=>{
		return {
			...bp,
			percentage: Math.round(bp.value / total * 100)
		}
	});
	const othersValue = breakpoints.slice(showBreakpoints).reduce((val, bp)=>{
		return val + bp.value;
	}, 0);
	result.push({
		key: "Others",
		value:othersValue,
		percentage: Math.round(othersValue / total * 100)

	});
	return result;
};

export const useLiveContents = ()=> useSelector(({live})=> live.contents);